<template>
    <AppJumbotron>
        <div class="flex items-center">
            <div class="flex-grow max-w-screen-md">
                <h1 class="text-white text-3xl md:text-5xl font-bold mb-8">
                    Genuine reviews to help you find the best tyres for your car
                </h1>

                <template v-if="route().has('search')">
                    <p class="text-white mb-4">Find reviews for tyres that match your car</p>

                    <div class="md:max-w-xs">
                        <AppSearchBar v-model="search" @search="$inertia.get(route('search'), {q: search})"
                                      placeholder="Find a tyre..."></AppSearchBar>
                    </div>
                </template>
            </div>
        </div>
    </AppJumbotron>

    <ExploreBrands :brands="brands"></ExploreBrands>

    <ScrollingReviewsBanner :reviews="recentReviews"></ScrollingReviewsBanner>

    <AppContainer class="pt-0">
        <LatestVideos class="my-16" :videos="latestVideos"></LatestVideos>

        <LatestNews class="my-16" :news="latestNews"></LatestNews>

        <HighestRatedTyres class="my-16"></HighestRatedTyres>

        <BrowseManufacturers class="my-16"></BrowseManufacturers>
    </AppContainer>
</template>

<script>
import MainLayout from "@/Layouts/MainLayout.vue";
import AppJumbotron from "@/Components/AppJumbotron.vue";
import AppSearchBar from "@/Components/AppSearchBar.vue";
import ExploreBrands from "@/Components/Brands/ExploreBrands.vue";
import ScrollingReviewsBanner from "@/Components/Reviews/ScrollingReviewsBanner";
import HighestRatedTyres from "@/Components/Products/Tyres/HighestRatedTyres";
import AppContainer from "@/Layouts/AppContainer";
import BrowseManufacturers from "@/Components/Manufacturers/BrowseManufacturers";
import LatestVideos from "@/Components/Videos/LatestVideos";
import LatestNews from "@/Components/News/LatestNews";

export default {
    layout: MainLayout,
    components: {
        LatestNews,
        LatestVideos,
        BrowseManufacturers,
        AppContainer,
        HighestRatedTyres,
        ScrollingReviewsBanner,
        AppJumbotron,
        AppSearchBar,
        ExploreBrands,
    },
    props: {
        brands: Array,
        recentReviews: Array,
        latestVideos: Array,
        latestNews: Array
    },
    data() {
        return {
            search: ""
        };
    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
